import { parseAcapsPopulation } from '../../functions/src/common/acapsPopulation';

export function formatAcapsPopulation(value: unknown, compact = false): string {
    const population = parseAcapsPopulation(value);
    return population === null ? 'Data Unavailable' : new Intl.NumberFormat('en-US', {
        notation: compact ? 'compact' : 'standard',
        maximumFractionDigits: compact ? 1 : 3,
    }).format(population);
}
